import React from 'react'
import FlexView from 'react-flexview/lib'
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService'
import { KPretty } from '../../../../services/utils'
import { isMobile } from 'react-device-detect'
import { PersonalInjuryPopover } from '../../../Core/Popover/PersonalInjuryPopover'

var classNames = require('classnames')

interface AdditionalCoveragesProps {
    personalInjuryLimitPremium: Number,
    personalInjuryLimit: Number,
    medicalExpenseLimitPremium: Number,
    medicalExpenseLimit: Number
}

export const AdditionalCoverages = ({personalInjuryLimitPremium, personalInjuryLimit, medicalExpenseLimitPremium, medicalExpenseLimit}: AdditionalCoveragesProps) => {

    return (<FlexView column={true}>
            <FlexView marginTop={15} className="space-between margin-bottom-basic ">
                <div className="text-body bold black">Additional Coverages <PersonalInjuryPopover /></div>
            </FlexView>
            {personalInjuryLimitPremium > 0 && 
                <FlexView column={true} className={classNames({"space-between": !isMobile} ,"margin-bottom-small")}>
                    <div className="black text-small">{KPretty(personalInjuryLimit)} Personal Injury Coverage (Including Privacy)</div>
                    <div className="gray margin-top-small text-tiny">
                        Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                        {personalInjuryLimitPremium.toLocaleStringToFixed()}
                    </div>
                </FlexView>}
            {medicalExpenseLimitPremium > 0 && 
                <FlexView column={true} className={classNames({"space-between": !isMobile} )}>
                    <div className="black text-small">{KPretty(medicalExpenseLimit)} Medical Expenses</div>
                    <div className="gray margin-top-small text-tiny">
                        Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                        {medicalExpenseLimitPremium.toLocaleStringToFixed()}
                    </div>
                </FlexView>}
        </FlexView>
    )
}